import { render, staticRenderFns } from "./FormatObjectSingleSelectDialog.vue?vue&type=template&id=60ee76db&scoped=true&"
import script from "./FormatObjectSingleSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectSingleSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectSingleSelectDialog.vue?vue&type=style&index=0&id=60ee76db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ee76db",
  null
  
)

export default component.exports